import { render } from "./VenditeList.vue?vue&type=template&id=f5db1884&ts=true"
import script from "./VenditeList.vue?vue&type=script&lang=ts"
export * from "./VenditeList.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\CarpeDiem\\AntiSmoking\\Backend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__